import { Link } from "react-router-dom";
import { MessageCircle, Phone, MapPin, Mail } from "lucide-react";
import SigniaBadge from "@/components/SigniaBadge";

export default function Footer() {
    return (
        <footer className="bg-[#0e1416] text-white relative overflow-hidden" data-testid="site-footer">
            <div className="container-x py-20">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-4">
                        <div className="font-serif text-[32px] leading-none">
                            signiastyletto<span className="text-[#7DCDD2]">ix</span>
                        </div>
                        <p className="eyebrow text-[#7DCDD2] mt-3">Powered by HearClear</p>
                        <div className="mt-5 inline-block bg-white rounded-xl p-3 shadow-[0_8px_24px_-16px_rgba(0,0,0,0.6)]">
                            <SigniaBadge variant="logo" data-testid="footer-signia-badge" className="!h-14" />
                        </div>
                        <p className="text-[#a1adb3] mt-6 text-[15px] leading-relaxed max-w-md">
                            Signia Certified Partner store for Styletto IX. Genuine devices, expert
                            fitting, lifetime service through HearClear's nationwide audiologist network.
                        </p>
                        <div className="mt-8 flex flex-col gap-3 text-[14px] text-[#cbd5dc]">
                            <a
                                href="https://wa.me/919971925446"
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex items-center gap-3 hover:text-white"
                                data-testid="footer-whatsapp"
                            >
                                <MessageCircle size={16} className="text-[#25D366]" />
                                +91 99719 25446 — WhatsApp
                            </a>
                            <a
                                href="tel:+919888438843"
                                className="inline-flex items-center gap-3 hover:text-white"
                                data-testid="footer-phone"
                            >
                                <Phone size={16} className="text-[#7DCDD2]" />
                                +91 98884 38843 — Call
                            </a>
                            <a
                                href="mailto:care@hearclear.in"
                                className="inline-flex items-center gap-3 hover:text-white"
                                data-testid="footer-email"
                            >
                                <Mail size={16} className="text-[#7DCDD2]" />
                                care@hearclear.in
                            </a>
                            <div className="inline-flex items-center gap-3">
                                <MapPin size={16} className="text-[#7DCDD2]" />
                                40+ HearClear clinics across India
                            </div>
                        </div>
                    </div>
                    <div className="md:col-span-2">
                        <p className="eyebrow text-[#7DCDD2]">Shop</p>
                        <ul className="mt-4 space-y-2 text-[14px] text-[#cbd5dc]">
                            <li><Link to="/products" className="hover:text-white">All Models</Link></li>
                            <li><Link to="/products/signia-styletto-1ix" className="hover:text-white">Styletto 1IX</Link></li>
                            <li><Link to="/products/kit-styletto-3ix" className="hover:text-white">Styletto 3IX</Link></li>
                            <li><Link to="/products/kit-styletto-7ix" className="hover:text-white">Styletto 7IX</Link></li>
                            <li><Link to="/compare" className="hover:text-white">Compare</Link></li>
                            <li><Link to="/learn" className="hover:text-white">Knowledge Centre</Link></li>
                            <li><Link to="/hearing-aids" className="hover:text-white">All Cities We Serve</Link></li>
                        </ul>
                    </div>
                    <div className="md:col-span-2">
                        <p className="eyebrow text-[#7DCDD2]">Services</p>
                        <ul className="mt-4 space-y-2 text-[14px] text-[#cbd5dc]">
                            <li><Link to="/book-trial" className="hover:text-white">Book Trial</Link></li>
                            <li><Link to="/hearing-test" className="hover:text-white">Online Hearing Test</Link></li>
                            <li><Link to="/find" className="hover:text-white">Hearing Aid Finder</Link></li>
                            <li><Link to="/support" className="hover:text-white">Support & Repair</Link></li>
                            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
                            <li><Link to="/upgrade" className="hover:text-white">Upgrade</Link></li>
                            <li><Link to="/clinics" className="hover:text-white">Clinics</Link></li>
                            <li><Link to="/seo/styletto-ix-emi" className="hover:text-white">EMI</Link></li>
                        </ul>
                    </div>
                    <div className="md:col-span-2">
                        <p className="eyebrow text-[#7DCDD2]">Resources</p>
                        <ul className="mt-4 space-y-2 text-[14px] text-[#cbd5dc]">
                            <li><Link to="/seo/signia-styletto-ix-price-india" className="hover:text-white">Price in India</Link></li>
                            <li><Link to="/seo/signia-styletto-ix-review" className="hover:text-white">Review</Link></li>
                            <li><Link to="/seo/signia-styletto-ix-features" className="hover:text-white">Features</Link></li>
                            <li><Link to="/seo/best-rechargeable-hearing-aids-india" className="hover:text-white">Best Rechargeable</Link></li>
                            <li><Link to="/seo/signia-styletto-vs-phonak" className="hover:text-white">vs Phonak</Link></li>
                        </ul>
                    </div>
                    <div className="md:col-span-2">
                        <p className="eyebrow text-[#7DCDD2]">Cities</p>
                        <ul className="mt-4 space-y-2 text-[14px] text-[#cbd5dc]">
                            <li><Link to="/seo/signia-styletto-delhi" className="hover:text-white">Delhi</Link></li>
                            <li><Link to="/seo/signia-styletto-gurgaon" className="hover:text-white">Gurgaon</Link></li>
                            <li><Link to="/seo/signia-styletto-mumbai" className="hover:text-white">Mumbai</Link></li>
                            <li><Link to="/seo/signia-styletto-bangalore" className="hover:text-white">Bangalore</Link></li>
                            <li><Link to="/seo/signia-styletto-chandigarh" className="hover:text-white">Chandigarh</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="mt-16 pt-8 border-t border-white/10">
                    <div className="flex flex-wrap gap-x-5 gap-y-2 text-[12px] text-[#9aa7ad]" data-testid="footer-legal-links">
                        <Link to="/policies/privacy-policy" className="hover:text-white">Privacy Policy</Link>
                        <Link to="/policies/terms-of-service" className="hover:text-white">Terms of Service</Link>
                        <Link to="/policies/returns-trial-policy" className="hover:text-white">Trial & Returns</Link>
                        <Link to="/policies/shipping-policy" className="hover:text-white">Shipping</Link>
                        <Link to="/policies/warranty-terms" className="hover:text-white">Warranty Terms</Link>
                        <Link to="/policies/medical-disclaimer" className="hover:text-white">Medical Disclaimer</Link>
                        <Link to="/policies/grievance-redressal" className="hover:text-white">Grievance Redressal</Link>
                        <Link to="/policies/accessibility-statement" className="hover:text-white">Accessibility</Link>
                    </div>
                    <div className="mt-6 flex flex-col md:flex-row gap-4 items-center justify-between text-[12px] text-[#7e8a91]">
                        <p>© {new Date().getFullYear()} signiastylettoix.com — Signia Certified Partner. Powered by HearClear. Not the official Signia website.</p>
                        <p>Hearing aid performance depends on hearing test and fitting.</p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
